
export const _vendorAdminRoutes = {
    login: "/login",
    dashboard: "/vendor-admin/dashboard",
    branches: "/vendor-admin/branches",
    branchDetails: (shopId) => `/vendor-admin/branch-details/${shopId}`,
    addBranch: `/vendor-admin/branch-details`,
    AddCoupon: `/vendor-admin/coupon-details`,
    services: "/vendor-admin/services",
    customersDetails: (customerId) =>`/vendor-admin/customers-details/${customerId}`, 
    complaintsDetails: (id) =>`/vendor-admin/complaints-details/${id}`, 
    servicesDetails: "/vendor-admin/services-details",
    staff: {
        list: '/vendor-admin/Staff',
        add: `/vendor-admin/Staffdetails`,
        edit: (id) => `/vendor-admin/Staffdetails/${id}`,
    },
    orders: {
        list: (query = {}) => {
            const params = new URLSearchParams(query).toString();
            return `/vendor-admin/orders${params ? `?${params}` : ""}`;
        },
        view: (id) => `/vendor-admin/order-detail/${id}`,
    }

    // orders: {
    //     list: '/vendor-admin/orders',
    //     view: (id) => `/vendor-admin/order-detail/${id}`,
    // }
}